// Reporting half of the DOM observer guard (DEV-3013).
//
// The repair itself lives in a blocking classic script at the top of
// index.html, because the constructors have to be sound before any module
// evaluates: dnd-core reads MutationObserver at module scope and builds one
// immediately, so anything the bundle does is already too late for it. That
// script leaves what it found on `window.__sunoDomObserverGuard`.
//
// Datadog is initialised well after boot, so this is what carries the finding
// off the browser — without it we cannot tell how many profiles are affected,
// or whether the repair worked on the ones that are.
import { datadogLogs } from "@datadog/browser-logs";

type DomObserverAnomaly = {
  observer: string;
  repaired: boolean;
};

declare global {
  interface Window {
    __sunoDomObserverGuard?: DomObserverAnomaly[];
  }
}

/**
 * Forwards anything the boot-time guard repaired (or failed to repair) to
 * Datadog, then clears the record so a second call cannot double-report.
 * Call once the Datadog SDK is configured.
 *
 * Never throws.
 */
export function reportDomObserverAnomalies(): void {
  try {
    const anomalies = window.__sunoDomObserverGuard;
    if (!anomalies || anomalies.length === 0) return;

    anomalies.forEach((anomaly) => {
      datadogLogs.logger.warn(
        "DOM observer constructor replaced by a non-constructible wrapper",
        anomaly
      );
    });
    window.__sunoDomObserverGuard = [];
  } catch {
    // Telemetry is not worth an exception on the boot path.
  }
}
